import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { S1DataService } from '../../services/s1data.service';
import { NatRepServiceService } from '../../services/nat-rep-service.service';
import { IQuota } from '../../models/IQuota';
import { ITarget } from '../../models/ITarget';
import { IQuotaTable } from '../../models/IQuotaTable';
import { NatRepQuotasRequest } from '../../models/INatRepQuotasRequest';
import { INatRepQuotasCalculated } from '../../models/INatRepQuotasCalculated';
import { Observable } from 'rxjs/Observable';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { catchError } from 'rxjs/operators';
import { _throw as throwError } from 'rxjs/observable/throw';
import { Utils } from '../../Utils';
import { ISample } from '../../models/ISample';

@Component({
	selector: 'feza-quota-picker',
	templateUrl: './quota-picker.component.html',
	styleUrls: ['./quota-picker.component.css']
})
export class QuotaPickerComponent implements OnInit, OnChanges {
	@Input() countryCode: string;
	@Input() locales: Array<string>;
	@Input() quotaTables: Array<IQuotaTable>;
  @Input() target: ITarget[];
  @Input() showNatRepPercentage: boolean; //show the nat rep percentages
  @Input() correlationId: string;
  @Output() quotasPicked: EventEmitter<IQuotaTable[]> = new EventEmitter();
  surveyId: string;
  quotaJson: string;
  calculateNatRepPercentagesError: string;

	constructor(
		private dataService: S1DataService,
		private natRepService: NatRepServiceService) {
	}

	ngOnInit() {
		this.quotaTables = this.quotaTables || [];
		this.locales = this.locales || [];
	}

	ngOnChanges() {
		this.quotaTables = this.quotaTables || [];
		this.locales = this.locales || [];
	}

	onImportClicked() {
		this.showNatRepPercentage = false;
		this.dataService.getQuotaTables(this.surveyId).subscribe(
			tables => {
				this.quotasPicked.emit(tables);
				this.quotaTables = tables;
			},
			error => console.log("onImportClicked ERROR:" + error));
	}

	onImportTextClicked() {
		this.showNatRepPercentage = false;
		let tables: Array<IQuotaTable> = JSON.parse(this.quotaJson);
		this.quotaTables = (tables !== null) ? tables : [];
		this.quotasPicked.emit(this.quotaTables);
  }

	onCalculateNatRepWithPanelEstimateClicked() {

		this.calculateNatRepPercentagesError = null;
		/*lets generate an Id*/
		this.quotaTables.forEach(qt => qt.quotas.forEach(q => { q.quotaId = Utils.generateUUID(); }));

		var requestQuotas = new NatRepQuotasRequest();
		requestQuotas.countryCode = this.countryCode;
		requestQuotas.countryCultures = this.locales;
		requestQuotas.quotaTables = this.quotaTables;
    requestQuotas.target = this.target;
    this.natRepService.CalculateNatRepQuotaPercentageWithPanelEstimate(requestQuotas, this.correlationId)
			.pipe(
        catchError(error => {
          this.calculateNatRepPercentagesError = error.error.detail == null ? error.message : error.error.detail;
					return throwError(this.calculateNatRepPercentagesError);
				}))
			.subscribe((calculatedQuotas: INatRepQuotasCalculated) => {
				if (!calculatedQuotas.responseCode) {
					for (let quotaTable of calculatedQuotas.quotaTables)
						for (let quota of quotaTable.quotas) {
							this.quotaTables.forEach(qt => qt.quotas.forEach(q => {
								if (q.quotaId === quota.quotaId) {
									q.natRepPercentage = quota.percentage;
								}
							}));
						}
					this.showNatRepPercentage = true;
				}
				else {
					this.calculateNatRepPercentagesError = calculatedQuotas.responseCode;

					calculatedQuotas.quotaTables.forEach(qt => qt.quotas.forEach(q => q.questions.forEach(quest => {
						if (quest.responseCode != "Ok") { this.calculateNatRepPercentagesError += " quota name: " + q.quotaName + ";" };
					})))

					calculatedQuotas.target.forEach(q => q.questions.forEach(quest => {
						if (quest.responseCode != "Ok") { this.calculateNatRepPercentagesError += " target question id: " + quest.id + ";" };
					}))
					this.showNatRepPercentage = true;
				}
			},
				err => {
					if (err.error) {
						this.calculateNatRepPercentagesError = err.error.title;
					}
				});
	}

	onApplyNatRepClicked() {
		this.quotaTables.forEach(qt => qt.quotas.forEach(q => { q.percentage = q.natRepPercentage }));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/quota-picker/quota-picker.component.ts